import { render } from "./stronaRejestracji.vue?vue&type=template&id=366dbd3f"
import script from "./stronaRejestracji.vue?vue&type=script&lang=js"
export * from "./stronaRejestracji.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__